import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/user_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  screen_name_cont: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'screenName',
  },
  email_cont: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'email',
  },
  role_id_eq: {
    column_type: 'belongs_to',
    column_name: 'role',
    extra: {
      model_name: 'Role',
      value_column: 'id',
    },
    model_name: 'User',
  },
  role: {
    column_type: 'belongs_to',
    column_name: 'role',
    extra: {
      model_name: 'Role',
      value_column: 'id',
    },
    model_name: 'User',
  },
  role_kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'business_executive', 'salesman', 'channel_business_executive', 'finance', 'customer_service', 'finance_manager', 'custom', 'merchandiser'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
  team_id_eq: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'teamIdEq',
  },
}
export const formColumnsConfig = {
  'self': {
    'screen_name': { required: true, disabledUpdate: false },
    'email': { required: true, disabledUpdate: false },
    'role_id': { required: false, disabledUpdate: false },
    'phone': { required: true, disabledUpdate: false },
    'customer_source_ids': { required: false, disabledUpdate: false },
    'related_user_ids': { required: false, disabledUpdate: false },
    'customer_capacity_limit': { required: false, disabledUpdate: false },
    'password': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('User', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('User', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
